import ApiService from "@/common/api/api.service";


const Anexo6_2 = {

    listar( empresaId, ano, anoFim, mesInicio, mesFim, ) {
        return ApiService.get(`Anexo62?Ano=${ano}${anoFim ? `&AnoFim=${anoFim}` : ''}${mesInicio ? `&MesInicio=${mesInicio}` : ''}${mesFim ? `&MesFim=${mesFim}`: ''}&EmpresaId=${empresaId}`);
    },

    salvar(form){
        return ApiService.put(`Anexo62`, form);
    }
}

export default Anexo6_2;
